import { Component, OnInit } from '@angular/core';
import { SedsModalAbstractComponent, SedsModalModule } from 'experian-design-system';
import { Labels } from '../../shared/labels';

@Component({
    selector: 'app-modal-error',
    imports: [
        SedsModalModule
    ],
    templateUrl: './modal-error.component.html',
    styleUrl: './modal-error.component.scss'
})
export class ModalErrorComponent extends SedsModalAbstractComponent implements OnInit {

  public dashboardLabels = new Labels().dashboardLabels;
  public title = this.dashboardLabels.modalErrorTitle;
  public desc = this.dashboardLabels.modalErrorDesc;

  constructor() {
    super();        
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

}
